// extracted by mini-css-extract-plugin
export default {"root":"Filter_root__vR0Ha","single-value__label":"Filter_single-value__label__F-Vxp","single-value__value":"Filter_single-value__value__CMslr"};